import Dropzone from './Dropzone.partial';

export default Dropzone;